<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-public-ip`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4a2 2 0 012-2h25a2 2 0 011.295.476l10 8.5A2 2 0 0144 12.5V44a2 2 0 01-2 2H7a2 2 0 01-2-2V4zm4 2h20.5v7.5a2 2 0 002 2H40V42H9V6zm24.5 5.5h4.235L33.5 7.9v3.6zM15 18v16.5h4V18h-4zm7 2v-2h6.5a5.5 5.5 0 110 11H26v5.5h-4V20zm4 5h2.5a1.5 1.5 0 000-3H26v3z"/></svg>
</template>
<script>

export default {
  name: 'IconPublicIp',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
